import { TableColumn } from './AuditLogsTableHeader.types';

// AI system is intentionally not a column here - it's shown in the row's
// expanded detail drawer instead, since on the per-AI-system feed it's
// always the same value, and on the org-wide feed it doesn't help scanning.
export const auditLogsTableColumns: TableColumn[] = [
  { label: 'Action', width: 'w-[38%]', sortable: true, sortKey: 'action' },
  { label: 'User', width: 'w-[22%]', sortable: true, sortKey: 'user' },
  { label: 'Type', width: 'w-[18%]', sortable: true, sortKey: 'type' },
  { label: 'Date', width: 'w-[22%]', sortable: true, sortKey: 'date' },
];

// Only used when a caller (e.g. the per-AI-system events feed) opts into a
// Severity column - the org-wide audit-logs endpoint has no per-entry severity.
export const auditLogsTableColumnsWithSeverity: TableColumn[] = [
  { label: 'Action', width: 'w-[32%]', sortable: true, sortKey: 'action' },
  { label: 'User', width: 'w-[18%]', sortable: true, sortKey: 'user' },
  { label: 'Type', width: 'w-[16%]', sortable: true, sortKey: 'type' },
  { label: 'Severity', width: 'w-[14%]', sortable: true, sortKey: 'changeImpact' },
  { label: 'Date', width: 'w-[20%]', sortable: true, sortKey: 'date' },
];
